import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ButtonToDashboard from '../ButtonToDashboard/ButtonToDashboard';
import cn from 'classnames';
import { declOfNum } from '../../../../helpers/dspx-utils';
import StatusesDropdown from './components/StatusesDropdown';
import { filtersData } from '../../constants/filtersData';
import { filterNames } from '../../constants/filterNames';
import { statusChangePeriodsMap } from '../../constants/statusChangePeriods';
import { statisticsPages } from '../../../../constants/statisticsPages';
import { expiredPeriodsMap } from '../../constants/expiredPeriods';
import styles from './InnerPageHeader.module.scss';

const InnerPageHeader = ({ title }) => {
  const { page } = useParams();

  const filteredRequests = useSelector(
    (state) => state.statisticsStore.filteredRequests
  );

  const getRequestCount = () => {
    const text = declOfNum(filteredRequests.length, [
      'заявка',
      'заявки',
      'заявок',
    ]);

    return `${filteredRequests.length} ${text}`;
  };

  return (
    <div className={cn(styles.root, styles.container)}>
      <ButtonToDashboard />
      <p className={styles.title}>
        {title} &middot; {getRequestCount()}
      </p>
      <div className={cn(styles.container, styles.rightContainer)}>
        {page === statisticsPages.active && (
          <StatusesDropdown
            filter={filtersData[filterNames.statusChangePeriod]}
            items={statusChangePeriodsMap}
            description="Период"
          />
        )}
        {page === statisticsPages.expired && (
          <StatusesDropdown
            filter={filtersData[filterNames.expiredPeriod]}
            items={expiredPeriodsMap}
            description="Период"
          />
        )}
      </div>
    </div>
  );
};

export default InnerPageHeader;
